const infoColors = {
  INFO_50: '#e1f5fe',
  INFO_100: '#b3e5fc',
  INFO_200: '#81d4fa',
  INFO_300: '#4fc3f7',
  INFO_400: '#2ab7f6',
  INFO_500: '#04aaf4',
  INFO_600: '#049ce5',
  INFO_700: '#0288D1',
  INFO_800: '#0278bd',
  INFO_900: '#01589b',
}

export default infoColors
